import React from 'react';

/**
 * Toolbar control to reset list filters to this page’s defaults.
 * Parent supplies onClick that clears local filter state (and pagination if needed).
 */
const ResetFiltersButton = ({ onClick, disabled = false, label = 'Reset filters' }) => (
  <button
    type="button"
    className="btn-secondary btn-sm"
    onClick={onClick}
    disabled={disabled}
    title="Clear filters on this page to their defaults"
  >
    {label}
  </button>
);

export default ResetFiltersButton;
